/**
 * User: Faris
 * Date: 6/24/13
 * Time: 4:30 PM
 */

define('app/views/page',['require','./slideshow','./anchored-image'],function(require) {

  var Slideshow = require('./slideshow');
  var AnchoredImage = require('./anchored-image');

  return Backbone.View.extend({

    className: 'page',
    assets: [],
    assetsTotal: 1,
    assetsLoaded: 0,
    rendered: false,
    rerender: true,
    dialog: null,
    slideshow: false,
    scroll: null,

    events: {
    },

    initialize: function(options){
      Backbone.View.prototype.initialize.call(this, options);
      _.bindAll(this, 'onResize', 'transitionInComplete', 'transitionOutComplete');      
    },

    transitionIn: function(curPage){
      this.beforeTransitionIn();
      TweenMax.to(this.$el, 0.75, { alpha: 1, onComplete: this.transitionInComplete, onCompleteScope: this });

      this.updateSlides();
      this.updateAnchoredImages();
      this.updateScrollbars();
      this.onResize();
      this.scrollTop();
      this.animateBackgroundSlideshow();
    },
    
    beforeTransitionIn: function() {
    },

    transitionInComplete: function(){
        this.scrollTop();
    },

    transitionOut: function(newPage){
      TweenMax.to(this.$el, 1, { alpha: 0, onComplete: this.transitionOutComplete, onCompleteScope: this });
    },

    transitionOutComplete: function(){
      this.$el.detach();
      if(this.BGtimer) {
          clearInterval(this.BGTimer);
      }
    },
    updateSlides: function(){
      if(this.model.get('SLIDES') && this.model.get('SLIDES').length){
        this.slideshow = new Slideshow({ el: $('.slideshow', this.$el) });
      }
    },

    updateAnchoredImages: function(){
      $('.anchored-image', this.$el).each(function(){
        new AnchoredImage({ el: $(this) });
      });
    },

    updateScrollbars: function(){
      $('.scroll', this.$el).mCustomScrollbar({
        updateOnBrowserResize: false,
        autoDraggerLength: false,
        scrollInertia: 500,
        mouseWheel: {
          scrollAmount: 200
        }
      });

      if($('.mCSB_container', this.$el).hasClass('mCS_no_scrollbar')){
        this.$el.addClass('no-scroll');
      }
    },

    onResize: function(e){
      $('.scroll', this.$el).each(function( ){
        $(this).mCustomScrollbar('update');
      });
      
      /*// Fix height of page bottom
      if($('.pageBtm', this.$el).length && $('.pageTop', this.$el).length) {
          var scrimH = $('.scrim', this.$el).height();
          var pageTop = $('.pageTop', this.$el).outerHeight();
          var newHeight = scrimH - pageTop;
          $('.pageBtm').css({height: newHeight});
      }*/
    },
    
    scrollTop: function() {
        $('html, body').animate({scrollTop: 0});
    },
    
    animateBackgroundSlideshow: function() {
        // Hide everything except first slide
        $('.mainBackground > .mainSlide:not(:first)', this.$el).each(function(i, ele) {
            $(ele).hide();
        });
        $(".mainBackground", this.$el).addClass("preloaded");
        
        if(this.model.attributes.slides1.length>1) {
            this.hasBGSlideshow = true;
            this.startBGTimer();
        }
    },
    
    startBGTimer: function() {
        var that = this;
        this.BGtimer = setInterval(function() {
            that.nextBGSlide(that);
        }, 7000);
    },
    
    nextBGSlide: function(that) {
        if(that.hasBGSlideshow) {
            // ANimate Next Slide
            $('.mainBackground > .mainSlide:first', this.$el).fadeOut(1000, function() {
                $(".mainBackground", this.$el).append($('.mainBackground > .mainSlide:first', this.$el));
                that.isBGAnimating = false;
            }.bind(that)).next().fadeIn(1000);
        }
    },
    
    prevBGSlide: function(that) {
        if(that.hasBGSlideshow) {
            $('.mainBackground > .mainSlide:last', this.$el).fadeIn(1000, function() {
                $(".mainBackground", this.$el).prepend($('.mainBackground > .mainSlide:last', this.$el));
                that.isBGAnimating = false;
            }.bind(that));
            $('.mainBackground > .mainSlide:first', this.$el).fadeOut(1000);
        }
    },
    
    pauseAndRestartBGTimer: function() {
        clearInterval(this.timer);          
        var thing = this;
        this.BGtimer = setInterval(function() {
            thing.nextSlide();
        }, 10000);
    },
    
    clickBGNext: function() {
        if(!this.isBGAnimating) {
            this.isBGAnimating = true;
            // Pause, then restart again    
            this.pauseAndRestartTimer();
            this.nextSlide();
        }
    },
    
    clickBGPrev: function() {         
        if(!this.isBGAnimating) {
            this.isBGAnimating = true;
            // Pause, then restart again
            this.pauseAndRestartTimer();
            this.prevSlide();
        }
    },

    render: function(){
      
        
      if(this.rerender || !this.rendered) {
        Backbone.View.prototype.render.call(this);
        this.$el.html(this.template(this.model.attributes));
        this.rendered = true;
      }
      
      this.afterRender();
      
      return this.$el;
    },
    
    afterRender: function() {
        
    },

    preload: function(){
    // Ancohor positions
    var anchors = new Array();
    anchors[0] = 'auto';
    anchors[1] = 'left top';
    anchors[2] = 'center top';
    anchors[3] = 'right top';
    anchors[4] = 'left center';
    anchors[5] = 'center center';
    anchors[6] = 'right center';
    anchors[7] = 'left bottom';
    anchors[8] = 'center bottom';
    anchors[9] = 'right bottom';
    
    this.model.attributes.ANCHORKEY = anchors;
    
    var template = this.template(this.model.attributes);
        
      var _self = this;

      this.assets = [];

      // get all slide as asset
      if(this.model.get('SLIDES')){
        var slides = this.model.get('SLIDES');
        for(var i =0;i<slides.length;i++) {
        	_self.assets.push('/content/slides/'+slides[i].IMAGE1);
        }
      }
      
      // Get all slides
      for(j=1;j<=8;j++) {      
          if(this.model.get('slides'+j)){
              var slides = this.model.get('slides'+j);
              for(var i =0;i<slides.length;i++) {
                  _self.assets.push('/content/slides/'+slides[i].IMAGE1);
              }
            }
      }
    
      // get all images in template as assets
      $('img:not(.no-preload)', template).each(function(){
        var src = $(this).attr('src');
        var dataSrc = $(this).attr('data-src');
        if(src || dataSrc){
          _self.assets.push(src || dataSrc);
        }
      });
      
      // Get all background images as assets
      $(".preloadBG, .preloaded, .slide", template).each(function() {
          var src = $(this).css('background-image');
          src = src.match(/\(([^)]+)\)/)[1];
          _self.assets.push(src);
      });
      
      var deferreds = [];
      for(var i = 0; i < this.assets.length; i++){          
        deferreds.push($.ajax({
          url:this.assets[i],
          success: function(){
            _self.assetsLoaded++;
            _self.trigger('assetLoaded', _self.assetsLoaded  / (_self.assets.length + 1)); //add one for page asset
          },
          error: function(){
            _self.assetsLoaded++;
            _self.trigger('assetLoaded', _self.assetsLoaded  / (_self.assets.length + 1)); //add one for page asset
          }
        }));
      }

      $.when.apply($, deferreds).done(function(){
        _self.trigger('loaded');
      }).fail(function(){
        _self.trigger('loaded');
      });

      this.assetsLoaded++;
      this.trigger('assetLoaded', 1 / (this.assets.length + 1));
    }

  });

});
